import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Row,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { API_BASE_URL } from "../../../_services/constant";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#000",
    backgroundColor: "#fff",
  },
  brandlogo: {
    maxWidth: "100%",
    height: "auto",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "110px",
      height: "110px",
    },
  },
  footer: {
    flexShrink: 0,
    width: "100%",
    backgroundColor: "#ffba3c",
    padding: theme.spacing(2),
    textAlign: "center",
    marginTop: "auto",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      fontSize: "0.8rem",
    },
  },
}));

const CustDesign = () => {
  const classes = useStyles();
  const fileInputRef = useRef(null);
  const [load, setLoad] = useState(false);
  const [subCat, setSubCat] = useState([]);
  const [category, setCategory] = useState("");
  const [remark, setRemark] = useState("");
  const [image, setImage] = useState(null);
  const [designs, setDesigns] = useState([]);
  const [modal, setModal] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);

  const [previewModal, setPreviewModal] = useState(false);
  const [selectedDesign, setSelectedDesign] = useState(null);

  const toggleModal = () => setModal(!modal);
  const togglePreviewModal = () => setPreviewModal(!previewModal);

  useEffect(() => {
    axios
      .post(`${API_BASE_URL}auth/get_product_setCategory`, {
        branch_id: localStorage.getItem("jwl_customer_branch_id"),
      })
      .then((response) => setSubCat(response.data))
      .catch((error) => console.error("API Error:", error));
  }, []);

  const handleAddDesign = () => {
    if (!image) return alert("Please choose an image!");
    if (!category) return alert("Please select a category!");

    const newDesign = {
      id: Date.now(),
      image,
      category,
      remark,
      name: localStorage.getItem("jwl_username"),
      logo: localStorage.getItem("jwl_logo"),
      brand_name: localStorage.getItem("jwl_brand_name"),
      customer_id: localStorage.getItem("jwl_customer_id"),
      branch_id: localStorage.getItem("jwl_customer_branch_id"),
      mobile: localStorage.getItem("cust_mobile"),
    };

    setDesigns([...designs, newDesign]);
    setImage(null);
    setCategory("");
    setRemark("");
  };

  const handleDeleteDesign = (id) => {
    setDesigns(designs.filter((d) => d.id !== id));
  };

  const handleSubmit = () => {
    if (designs.length === 0) return alert("Please add at least one design!");
    setIsBlinking(true);
    setTimeout(() => setIsBlinking(false), 300);
    toggleModal();
  };

  const designUploader = async (data) => {
    try {
      await axios.post(`${API_BASE_URL}auth/upload/design`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    } catch (error) {
      alert("Failed to upload image: " + error.message);
    }
  };

  const saveAllDesigns = async () => {
    setLoad(true);
    for (const item of designs) {
      const formData = new FormData();
      formData.append("tran_id", "0");
      formData.append("voucher_id", 52);
      formData.append("category", item.category);
      formData.append("image", item.image);
      formData.append("remark", item.remark);
      formData.append("name", item.name);
      formData.append("logo", item.logo);
      formData.append("brand_name", item.brand_name);
      formData.append("customer_id", item.customer_id);
      formData.append("branch_id", item.branch_id);
      formData.append("mobile", item.mobile);
      formData.append("entry_date", moment().format("YYYY-MM-DDTHH:mm:ssZ"));
      await designUploader(formData);
    }
    setDesigns([]);
    setImage(null);
    setCategory("");
    setRemark("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setLoad(false);
    redirectAfterSubmission();
  };

  const redirectAfterSubmission = () => {
    const insta = localStorage.getItem("jwl_instagram");
    const facebook = localStorage.getItem("jwl_facebook");
    const twitter = localStorage.getItem("jwl_twitter");
    if (insta) window.open(`https://www.instagram.com/${insta}`, "_blank");
    else if (facebook) window.open(`https://www.facebook.com/${facebook}`, "_blank");
    else if (twitter) window.open(`https://www.twitter.com/${twitter}`, "_blank");
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${localStorage.getItem("branch_contact")}`;
  };

  const year = new Date().getFullYear();
  const branchName = localStorage.getItem("jwl_branch_name") || "Your Branch";
  const branchFacebook = localStorage.getItem("jwl_facebook");
  const branchInstagram = localStorage.getItem("jwl_instagram");
  const branchLinkedin = localStorage.getItem("jwl_linkedin");
  const branchTwitter = localStorage.getItem("jwl_twitter");

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Loader */}
      <Backdrop className={classes.backdrop} open={load}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className="container pb-3" style={{ maxWidth: "900px", flex: "1 0 auto" }}>
        {/* Logo & Phone */}
        <div className="d-flex justify-content-between align-items-center my-4">
          <img
            className={`img-fluid ${classes.brandlogo}`}
            src={`${API_BASE_URL}BranchLogo/${localStorage.getItem("jwl_logo")}`}
            style={{ maxHeight: "80px", objectFit: "contain" }}
            alt="Brand Logo"
          />
          <Button color="link" onClick={handlePhoneClick} style={{ textDecoration: "none" }}>
            <PhoneIcon style={{ color: "#1bc5bd", fontSize: "2rem" }} />
          </Button>
        </div>

        {/* Add Design Card */}
        <Card className="my-3 shadow-lg" style={{ borderRadius: "12px", border: "none" }}>
          <CardHeader tag="h5" style={{ backgroundColor: "#fff", borderBottom: "1px solid #f0f0f0", padding: "20px", fontWeight: "700", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
            Add Your Design
          </CardHeader>
          <CardBody style={{ padding: "20px" }}>
            <CardText>
              <Row>
                {/* Left Column: Image Preview Dropzone */}
                <div className="col-md-6 mb-3 d-flex flex-column align-items-center justify-content-center">
                  <div
                    onClick={() => fileInputRef.current.click()}
                    style={{
                      width: "100%",
                      maxWidth: "280px",
                      aspectRatio: "1/1",
                      border: image ? "none" : "2px dashed #1bc5bd",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      backgroundColor: image ? "transparent" : "#f8fdfd",
                      overflow: "hidden",
                      cursor: "pointer",
                      boxShadow: image ? "0 8px 20px rgba(0,0,0,0.15)" : "none",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => { if(!image) e.currentTarget.style.backgroundColor = "#eaf8f8"; }}
                    onMouseLeave={(e) => { if(!image) e.currentTarget.style.backgroundColor = "#f8fdfd"; }}
                  >
                    {image ? (
                      <>
                        <img
                          src={URL.createObjectURL(image)}
                          alt="Preview"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                        <div style={{
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          backgroundColor: "rgba(0,0,0,0.6)",
                          color: "#fff",
                          padding: "5px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          pointerEvents: "none"
                        }}>
                          Change Image
                        </div>
                      </>
                    ) : (
                      <div className="text-center text-muted">
                        <ImageNotSupportedIcon style={{ fontSize: "4rem", color: "#1bc5bd", marginBottom: "15px" }} />
                        <div style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>Tap to Browse Image</div>
                        <div style={{ fontSize: "12px", marginTop: "5px" }}>Supports JPG, PNG, WEBP</div>
                      </div>
                    )}
                  </div>

                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => setImage(e.target.files[0])}
                    style={{ display: "none" }}
                    accept="image/*"
                  />
                </div>

                {/* Right Column: Details & Add Button */}
                <div className="col-md-6 d-flex flex-column justify-content-center">
                  <div className="mb-3">
                    <label style={{ fontWeight: "600", color: "#444", marginBottom: "8px" }}>Select Category</label>
                    <Input
                      style={{ 
                        width: "100%", 
                        padding: "10px 15px", 
                        border: "1px solid #e0e0e0", 
                        borderRadius: "8px",
                        height: "auto",
                        color: "#555",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.02)"
                      }}
                      type="select"
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <option value="">Select Category...</option>
                      {subCat.map((option) => (
                        <option key={option.id} value={option.category_name}>
                          {option.category_name}
                        </option>
                      ))}
                    </Input>
                  </div>

                  <div className="mb-3">
                    <label style={{ fontWeight: "600", color: "#444", marginBottom: "8px" }}>Remark (Optional)</label>
                    <Input
                      type="textarea"
                      placeholder="Add any specific instructions or notes..."
                      rows="3"
                      style={{ 
                        width: "100%", 
                        padding: "10px 15px", 
                        border: "1px solid #e0e0e0", 
                        borderRadius: "8px",
                        color: "#555",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.02)",
                        resize: "none"
                      }}
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>

                  <div>
                    {designs.length < 5 ? (
                      <Button 
                        onClick={handleAddDesign}
                        style={{
                          width: "100%",
                          backgroundColor: "#1bc5bd",
                          color: "white",
                          padding: "12px",
                          borderRadius: "8px",
                          border: "none",
                          fontWeight: "bold",
                          fontSize: "16px",
                          boxShadow: "0 4px 10px rgba(27, 197, 189, 0.3)",
                        }}
                      >
                        <AddCircleIcon style={{ marginRight: "8px" }} /> Add to Collection
                      </Button>
                    ) : (
                      <div className="text-danger text-center" style={{ fontWeight: "600", padding: "12px" }}>
                        Maximum of 5 designs reached.
                      </div>
                    )}
                  </div>
                </div>
              </Row>
            </CardText>

            {/* Gallery Section inside CardBody */}
            {designs.length > 0 && (
              <div className="mt-4 pt-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                <h5 style={{ fontWeight: "700", marginBottom: "15px", color: "#333" }}>
                  Your Added Designs ({designs.length})
                </h5>
                <div className="d-flex flex-wrap mb-4" style={{ gap: "15px" }}>
                  {designs.map((d) => (
                    <div
                      key={d.id}
                      style={{
                        position: "relative",
                        width: "70px",
                        height: "70px",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                        transition: "transform 0.2s ease"
                      }}
                      onClick={() => {
                        setSelectedDesign(d);
                        togglePreviewModal();
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                      onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                      <img
                        src={URL.createObjectURL(d.image)}
                        alt="thumb"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          backgroundColor: "#f44336",
                          color: "#fff",
                          borderRadius: "50%",
                          cursor: "pointer",
                          fontSize: "12px",
                          width: "22px",
                          height: "22px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          boxShadow: "0 2px 6px rgba(244, 67, 54, 0.4)",
                          zIndex: 2
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteDesign(d.id);
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-center">
                  <Button
                    onClick={handleSubmit}
                    className={`${isBlinking ? "blink" : ""}`}
                    style={{
                      width: "100%",
                      maxWidth: "400px",
                      backgroundColor: "#ffc107",
                      color: "#333",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px",
                      fontWeight: "bold",
                      fontSize: "16px",
                      textAlign: "center",
                      boxShadow: "0 4px 12px rgba(255, 193, 7, 0.4)",
                      transition: "transform 0.2s ease"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.02)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                  >
                    Submit All Designs
                  </Button>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      </div>

      {/* Footer */}
      <footer style={{ backgroundColor: "#ffc107", color: "#333", padding: "12px 0", width: "100%", marginTop: "auto" }}>
          <div className="container mcntr">
            <div className="row align-items-center">
              <div className="col-sm-6 text-left" style={{ fontSize: "13px", fontWeight: "600" }}>
                © {year} {branchName} All Rights Reserved
              </div>
              <div className="col-sm-6">
                <div className="text-right d-flex justify-content-end align-items-center" style={{ gap: "20px" }}>
                  {branchFacebook ? (
                    <a href={branchFacebook} style={{ color: "#333" }}>
                      <i
                        id="social-fb"
                        className="fa fa-facebook fa-lg social"
                      ></i>
                    </a>
                  ) : null}
                  {branchInstagram ? (
                    <a href={branchInstagram} style={{ color: "#333" }}>
                      <i
                        id="social-gp"
                        className="fa fa-instagram fa-lg social"
                      ></i>
                    </a>
                  ) : null}
                  {branchLinkedin ? (
                    <a href={branchLinkedin} style={{ color: "#333" }}>
                      <i
                        id="social-em"
                        className="fa fa-linkedin fa-lg social"
                      ></i>
                    </a>
                  ) : null}
                  {branchTwitter ? (
                    <a href={branchTwitter} style={{ color: "#333" }}>
                      <i
                        id="social-tw"
                        className="fa fa-twitter fa-lg social"
                      ></i>
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </footer>

      {/* Confirmation Modal */}
      <Modal isOpen={modal} fade={false} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Upload Design</ModalHeader>
        <ModalBody>Are you sure you want to submit?</ModalBody>
        <ModalFooter className="d-block">
          <Button
            color="primary"
            className="w-100"
            onClick={() => {
              saveAllDesigns();
              toggleModal();
            }}
          >
            Submit
          </Button>
          <Button color="secondary" className="w-100 mt-2" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      {/* Preview Modal */}
      {selectedDesign && (
        <Modal isOpen={previewModal} toggle={togglePreviewModal}>
          <ModalHeader toggle={togglePreviewModal}>Design Preview</ModalHeader>
          <ModalBody>
            <Card>
              <img
                src={URL.createObjectURL(selectedDesign.image)}
                alt="preview"
                style={{ width: "100%", objectFit: "cover", borderRadius: "8px" }}
              />
              <CardBody>
                <h6>Category: {selectedDesign.category}</h6>
                <p>Remark: {selectedDesign.remark || "No remark"}</p>
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={togglePreviewModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
};

export default CustDesign;
